import React from 'react';
import type { AssetAnalysisData } from '../types';

interface TopPerformersListProps {
  performers: AssetAnalysisData['topPerformers'];
  formatAmount: (amount: number) => string;
  formatReturnRate: (rate: number) => string;
}

/**
 * 收益贡献排行 TOP3 组件
 */
export const TopPerformersList: React.FC<TopPerformersListProps> = ({
  performers,
  formatAmount,
  formatReturnRate
}) => {
  return (
    <div className="rounded-lg bg-white p-4 shadow-md">
      <div className="mb-4 text-base font-semibold text-[#1F1F1F]">收益贡献排行 TOP3</div>
      <div className="space-y-3">
        {performers.map((performer, index) => (
          <div
            key={performer.id}
            className={`flex items-center gap-2 ${index < performers.length - 1 ? 'border-b border-gray-200 pb-3' : ''}`}
          >
            {/* 排名图标 */}
            <div className="flex h-6 w-6 items-center justify-center rounded-full bg-[#5959EB] text-white">
              <span className="text-xs font-semibold">{performer.rank}</span>
            </div>

            {/* 产品信息 */}
            <div className="flex-1">
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-sm text-[#1F1F1F]">{performer.name}</div>
                  <div className="text-xs text-[#8C8C8C]">{performer.code}</div>
                </div>
                <div className="text-right">
                  <div className="text-sm text-[#1F1F1F]">{formatAmount(performer.profit)}</div>
                  <div className="text-xs text-[#1F1F1F]">
                    {formatReturnRate(performer.returnRate)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
